import React from "react";
import Chart from "react-apexcharts";

const MyCharts = () => {
  const series = [
    //data on the y-axis
    {
      name: "Price",
      data: [
        179, 180, 180, 180, 180, 180, 180, 180, 180, 180, 180, 180, 180, 180,
        180, 180, 180, 180, 180, 180, 180, 181, 181, 181, 181, 181, 181, 181,
        181, 181, 181, 181, 181, 181, 181, 181, 181, 181, 181, 181, 181, 181,
        181, 181, 181, 181, 181, 181, 181, 181, 182, 182, 182, 182, 182, 182,
        182, 182, 182, 182, 182, 182, 182, 182, 182, 182, 182, 182, 182, 182,
        182, 182, 183, 183, 183, 183, 183, 183, 183, 183, 183, 183, 183, 183,
        183, 183, 183, 183, 183, 183,
      ],
      colors: ["ffffff"],
    },
  ];
  const options = {
    //data on the x-axis
    chart: { id: "bar-charts" },

    xaxis: {
      categories: [
        "2023-06-11",
        "2023-06-12",
        "2023-06-13",
        "2023-06-14",
        "2023-06-15",
        "2023-06-16",
        "2023-06-17",
        "2023-06-18",
        "2023-06-19",
        "2023-06-20",
        "2023-06-21",
        "2023-06-22",
        "2023-06-23",
        "2023-06-24",
        "2023-06-25",
        "2023-06-26",
        "2023-06-27",
        "2023-06-28",
        "2023-06-29",
        "2023-06-30",
        "2023-07-01",
        "2023-07-02",
        "2023-07-03",
        "2023-07-04",
        "2023-07-05",
        "2023-07-06",
        "2023-07-07",
        "2023-07-08",
        "2023-07-09",
        "2023-07-10",
        "2023-07-11",
        "2023-07-12",
        "2023-07-13",
        "2023-07-14",
        "2023-07-15",
        "2023-07-16",
        "2023-07-17",
        "2023-07-18",
        "2023-07-19",
        "2023-07-20",
        "2023-07-21",
        "2023-07-22",
        "2023-07-23",
        "2023-07-24",
        "2023-07-25",
        "2023-07-26",
        "2023-07-27",
        "2023-07-28",
        "2023-07-29",
        "2023-07-30",
        "2023-07-31",
        "2023-08-01",
        "2023-08-02",
        "2023-08-03",
        "2023-08-04",
        "2023-08-05",
        "2023-08-06",
        "2023-08-07",
        "2023-08-08",
        "2023-08-09",
        "2023-08-10",
        "2023-08-11",
        "2023-08-12",
        "2023-08-13",
        "2023-08-14",
        "2023-08-15",
        "2023-08-16",
        "2023-08-17",
        "2023-08-18",
        "2023-08-19",
        "2023-08-20",
        "2023-08-21",
        "2023-08-22",
        "2023-08-23",
        "2023-08-24",
        "2023-08-25",
        "2023-08-26",
        "2023-08-27",
        "2023-08-28",
        "2023-08-29",
        "2023-08-30",
        "2023-08-31",
        "2023-09-01",
        "2023-09-02",
        "2023-09-03",
        "2023-09-04",
        "2023-09-05",
        "2023-09-06",
        "2023-09-07",
        "2023-09-08",
      ],
    },
  };

  return (
    <div id="predict">
      <Chart options={options} series={series} type="line" width="530" />
      {/* <Chart options={options} series={series} type="line" width="550" /> */}
    </div>
  );
};

export default MyCharts;
